import type { Language } from './content-pages';

/**
 * Where the storefront lives, for "View on store" and the previews of how a
 * page reads in a search result (ADR-058). Configuration, never a literal
 * (ADR-015): `VITE_STOREFRONT_URL` at build time. In development the
 * storefront's own default port stands in, as the storefront does for itself;
 * a production build without it shows paths and offers no link.
 */
export function storefrontOrigin(): string | null {
  const configured = import.meta.env.VITE_STOREFRONT_URL;
  if (configured) return configured.replace(/\/$/, '');
  return import.meta.env.DEV ? 'http://localhost:3001' : null;
}

/** A store path in a language: Arabic at the root, English under `/en` (ADR-017). */
export function storefrontPath(language: Language, path: string): string {
  return language === 'ar' ? path : `/en${path}`;
}

/** The full address of a store path, or null where the storefront's address is not configured. */
export function storefrontUrl(language: Language, path: string): string | null {
  const origin = storefrontOrigin();
  return origin ? `${origin}${storefrontPath(language, path)}` : null;
}
